import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <header className="header">
        <div className="container">
          <div className="logo">
            <Link to="/">
              <h1>Heni</h1>
            </Link>
          </div>
          <nav className="nav">
            <Link to="/" className="back-link">← Back to Home</Link>
          </nav>
        </div>
      </header>

      <main className="legal-content">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Information We Collect</h2>
            <p>
              At Heni, we collect information you provide directly to us, such as when you create an account, 
              interact with your AI avatar, or contact us for support. This may include:
            </p>
            <ul>
              <li>Personal information (name, email address, profile information)</li>
              <li>Conversation data with your AI avatar</li>
              <li>Usage data and preferences</li>
              <li>Device information and technical data</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, maintain, and improve our AI avatar services</li>
              <li>Personalize your experience and avatar interactions</li>
              <li>Communicate with you about our services</li>
              <li>Ensure the security and integrity of our platform</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2>3. Information Sharing and Disclosure</h2>
            <p>
              We do not sell, trade, or otherwise transfer your personal information to third parties without
              your consent, except as described in this policy. We may share information:
            </p>
            <ul>
              <li>With service providers who assist in our operations</li>
              <li>When required by law or to protect our rights</li>
              <li>In connection with a business transaction</li>
              <li>With your explicit consent</li>
            </ul>

            <h3>Third-Party Services</h3>
            <p>
              To provide our AI avatar services, we use the following third-party service providers that may
              process or store your data:
            </p>
            <ul>
              <li><strong>Supabase:</strong> We use Supabase for authentication, database storage, and file storage.
              Your account information, profile data, and content may be stored on Supabase's infrastructure.</li>
              <li><strong>OpenAI:</strong> We use OpenAI's language models to power AI avatar conversations and
              interactions. Your conversation data is processed through OpenAI's API to generate responses.</li>
              <li><strong>Replicate:</strong> We use Replicate for additional AI services including image generation
              and other AI-powered features. Content you create or request may be processed through Replicate's platform.</li>
            </ul>
            <p>
              These third-party services have their own privacy policies and data handling practices. We encourage
              you to review their policies. We only share the minimum necessary data required to provide our services.
            </p>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal information 
              against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission 
              over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h2>5. Your Rights and Choices</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access and update your personal information</li>
              <li>Delete your account and associated data</li>
              <li>Opt out of certain communications</li>
              <li>Request a copy of your data</li>
              <li>Object to certain processing activities</li>
            </ul>
          </section>

          <section>
            <h2>6. Children's Privacy</h2>
            <p>
              Our services are not intended for children under 13 years of age. We do not knowingly collect 
              personal information from children under 13. If we become aware that we have collected personal 
              information from a child under 13, we will take steps to delete such information.
            </p>
          </section>

          <section>
            <h2>7. International Data Transfers</h2>
            <p>
              Your information may be transferred to and processed in countries other than your own. We ensure 
              appropriate safeguards are in place to protect your information in accordance with this privacy policy.
            </p>
          </section>

          <section>
            <h2>8. Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. We will notify you of any changes by posting 
              the new privacy policy on this page and updating the "Last updated" date.
            </p>
          </section>

          <section>
            <h2>9. Contact Us</h2>
            <p>
              If you have any questions about this privacy policy or our privacy practices, please contact us at:
            </p>
            <div className="contact-info">
              <p>Email: info@heniapp.ai</p>
            </div>
          </section>
        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-links">
              <Link to="/">Home</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
            <p>&copy; 2024 Heni. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy; 